const urlUploadComplaintAgiliza = "/storage-agiliza/";
export default {
  createComplaintAgilizaAnexe(signature, axios, form, file) {
    let formComplaint = form;
    let formData = new FormData();
    let entries = Object.entries(formComplaint);
    Object.keys(formComplaint).forEach((key) => {
      form[key] = form[key] + "";
    });
    entries.forEach((entry) => {
      formData.append(entry[0], entry[1]);
    });
    // files.anexesTechnicalSupport.forEach((file, index) => {
      formData.append(`file`, file);
    // });
    let sign = signature(formComplaint);
    return axios
      .post(urlUploadComplaintAgiliza, formData, {
        headers: { "X-SFC-Signature": sign },
      })
      .then((response) => ({ data: response.data }))
      .catch((error) => ({ error: error?.response?.data }));
  },
};
